export default "__VITE_ASSET__BoEPdRQt__"